module.exports = __webpack_public_path__ + "assets/img/21_765_big.43fc0473.jpg";